module.exports = __webpack_public_path__ + "img/find-locum-bg.c835dd43.jpg";